import gql from 'graphql-tag';

export const PASSWORD_RESET = gql`
    mutation passwordReset ($email: EmailAddress!) {
        passwordReset (email: $email)
    }
`;

export default PASSWORD_RESET;